import { isEqual } from "lodash";
import { NullLocalCopyException } from "./exceptions/null-local-copy-exception";
import { StaleLocalCopyException } from "./exceptions/stale-local-copy-exception";

export type Check<T> = {
  name: string;
  function: (localCopy: T, databaseCopy: T) => boolean;
};

export class EntityHelper {
  public static validateLocalCopy<T>(localCopy: T | null, databaseCopy: T, checks: Check<T>[]): void {
    if (localCopy == null) {
      throw new NullLocalCopyException();
    }

    const failedCheckNames = checks.filter(check => !check.function(localCopy, databaseCopy)).map(check => check.name);
    if (failedCheckNames.length > 0) {
      throw new StaleLocalCopyException(localCopy, failedCheckNames, databaseCopy);
    }
  }

  public static checkAllFieldsEqual<T>(obj1: T, obj2: T): boolean {
    return isEqual(obj1, obj2);
  }
}